
import {parseRoute as _parseRoute} from './query/src/route_parsing.js';
import {DevFunction, ArgTypeError, getAbsolutePath as _getAbsolutePath} from
  '../interpreting/ScriptInterpreter.js';



export const parseRoute = new DevFunction(
  "parseRoute", {typeArr: ["string"]},
  ({callerNode, execEnv}, [route]) => {
    try {
      return _parseRoute(route);
    }
    catch (msg) {
      throw new ArgTypeError(msg, callerNode, execEnv);
    }
  },
);


export const isTextFileExtension = new DevFunction(
  "isTextFileExtension", {typeArr: ["string"]}, ({}, [fileExt]) => {
    return /^(.+\.)?(jsx?|mjs|txt|json|html|xml|svg|md|css)$/.test(fileExt);
  },
);


export const getAbsolutePath = new DevFunction(
  "getAbsolutePath", {typeArr: ["string", "string?"]},
  ({callerNode, execEnv}, [path, curPath]) => {
    curPath ??= execEnv.getModuleEnv().modulePath;
    return _getAbsolutePath(curPath, path, callerNode, execEnv);
  },
);


export const getHomePath = new DevFunction(
  "getHomePath", {typeArr: ["string?"]}, ({execEnv}, [route]) => {
    route ??= execEnv.getModuleEnv().modulePath;
    let [ , homePath] = /^(\/[^/]*\/[^/]*)/.exec(route) ?? [];
    return homePath;
  },
);

export const getHomeDirID = new DevFunction(
  "getHomeDirID", {typeArr: ["string?"]}, ({execEnv}, [route]) => {
    route ??= execEnv.getModuleEnv().modulePath;
    let [ , homeDirID] = /^\/[^/]*\/([^/]*)/.exec(route) ?? [];
    return homeDirID;
  },
);

export const getNodeID = new DevFunction(
  "getNodeID", {typeArr: ["string?"]}, ({execEnv}, [route]) => {
    route ??= execEnv.getModuleEnv().modulePath;
    let [ , nodeID] = /^\/([^/]*)\/[^/]*/.exec(route) ?? [];
    return nodeID;
  },
);

export const getNodeAndHomeDirID = new DevFunction(
  "getNodeID", {typeArr: ["string?"]}, ({execEnv}, [route]) => {
    route ??= execEnv.getModuleEnv().modulePath;
    let [ , nodeID, homeDirID] = /^\/([^/]*)\/([^/]*)/.exec(route) ?? [];
    return [nodeID, homeDirID];
  },
);